import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { RadioButtonGroup } from '../../ui';

const PrivacySettings = ({
    t,
    privateProfile,
    setProfileToPrivate,
    setProfileToPublic,
}) => (
    <RadioButtonGroup
        options={[{
            name: t('privateHeader'),
            isSelected: privateProfile,
            setOption: setProfileToPrivate,
            description: t('privateHeaderDescription'),
        }, {
            name: t('publicHeader'),
            isSelected: !privateProfile,
            setOption: setProfileToPublic,
            description: t('publicHeaderDescription'),
        }]}
    />
);

PrivacySettings.propTypes = {
    privateProfile: PropTypes.bool.isRequired,
    setProfileToPrivate: PropTypes.func.isRequired,
    setProfileToPublic: PropTypes.func.isRequired,
};

export default translate(['workoutPartners'], { wait: true })(PrivacySettings);
